import { useQuery } from '@tanstack/react-query';

import { getConfig } from '../../../config/envConfig';
import queryUserFromAGG from '../../../utils/queryUserFromAGG';

export const avatarByAccountIdQueryKey = 'avatarByAccountIdQueryKey';

type UserData = {
  id: string;
  fullName: string;
  avatarUrl: string;
};

export type AvatarByAccountIdQueryData = {
  data: UserData;
};

const getAvatarAndFullNameByAccountIdQueryFn = async (
  userId: string,
  size: number,
): Promise<UserData> => {
  const { stargateRoot } = getConfig();
  if (!userId) {
    return {
      id: '',
      fullName: '',
      avatarUrl: '',
    };
  }

  const aggUrl = `${stargateRoot}/graphql?q=AvatarByAccountIdQuery`;
  const { id, name: fullName, picture: avatarUrl } = await queryUserFromAGG({
    userId,
    url: aggUrl,
  });

  return {
    id,
    fullName,
    avatarUrl,
  };
};

export const useAvatarByAccountIdQuery = (userId: string, size: number) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [avatarByAccountIdQueryKey, userId],
    queryFn: () => getAvatarAndFullNameByAccountIdQueryFn(userId, size),
  });

  return { avatarByAccountIdData: data, isLoading, isError };
};
